import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import ImageGallery from 'react-image-gallery'
import Box from '@mui/material/Box'
import EmptyComponent from './UIComponent/EmptyComponent.js'
import DisplayPropertyLayout from './UIComponent/DisplayPropertyLayout.js'
import ActivityMetaData from './UIComponent/ActivityMetaData.js'
import CheckListLayout from './UIComponent/CheckListLayout.js'
import AtAGlanceLayout from './UIComponent/AtAGlanceLayout.js'
import BulletListLayout from './UIComponent/BulletListLayout.js'
import AdditionalInfoLayout from './UIComponent/AdditionalInfoLayout.js'
import SourceLayout from './UIComponent/SourceLayout.js'
import TextLayout from './UIComponent/TextLayout.js'
import KeyValueLayout from './UIComponent/KeyValueLayout.js'
import HotelSeparatorLayout from './UIComponent/HotelSeparatorLayout.js'
import 'react-image-gallery/styles/css/image-gallery.css'
import itenary from '../../assets/images/itenary.png'
import importantInfo from '../../assets/images/importantInfo.png'
import additionalInfo from '../../assets/images/additionalInfo.png'
import exclamationmark from '../../assets/images/exclamationmark.svg'
import viator from '../../assets/images/viator.svg'
import Slider from './Slider.js'
import { activity_data } from './activity_data.js'
import { attraction_data } from './attraction_data.js'
import { hotel_data } from './hotel_data.js'
import muteIcon from '../../assets/images/icons/mute-icon.svg'
import unmuteIcon from '../../assets/images/icons/unmute-icon.svg'

import { useLocation, useNavigate } from 'react-router-dom'
import {
  getDataForLayout,
  getImagesFromHotelProperties,
  getImagesSlidesFromHotelProperties,
  imagesGalleryModal,
  imagesSlidesModal,
  videosGalleryModal,
  videosSlidesModal,
} from './DetailPageDataUtils.js'
import { isEmpty, orderBy, sortBy } from 'lodash'
import { string } from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import {
  getDetailPageDataAsync,
  getImagesGalleryDataAsync,
  getVideosGalleryDataAsync,
} from '../../redux/services/apiCalls.js'
import {
  fetchCurrentState,
  fetchDetailPageState,
  fetchImagesGallery,
  fetchVideosGallery,
  flushDetailPageData,
  flushImagesGalleryData,
  flushVideosGalleryData,
} from '../../redux/features/customerViewSlice.js'
import { useEffect } from 'react'
import MetaDataLayout from './UIComponent/MetaDataLayout.js'
import HotelTransportLayout from './UIComponent/HotelTransportLayout.js'
import StayFeaturedLayout from './UIComponent/StayFeaturedLayout.js'
import StayTipsLayout from './UIComponent/StayTipsLayout.js'
import CustomListLayout from './UIComponent/CustomListLayout.js'
import TripBannerLayout from './UIComponent/TripBannerLayout.js'
import HotelAmenityLayout from './UIComponent/HotelAmenityLayout.js'
import LineSeparatorLayout from './UIComponent/LineSeparatorLayout.js'
import ReviewLayout from './UIComponent/ReviewLayout.js'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper'
import ShareButton from '../common/ShareButton/ShareWhite.js'
import navigateBack from '../../assets/images/icons/navigate-left-white.svg'
import goBack from '../../assets/images/icons/go-back.svg'
import { checkUndefined } from '../../util.js'
import { v4 } from 'uuid'
import Loader from '../common/Loader.js'
// React Gallery Carousel
import Carousel from 'react-gallery-carousel'
import 'react-gallery-carousel/dist/index.css'
import newLeft from '../../assets/images/icons/new-left.svg'
import newRight from '../../assets/images/icons/new-right.svg'
import inactive from '../../assets/images/icons/inactive-dot.svg'
import active from '../../assets/images/icons/active-dot.svg'
import viewAll from '../../assets/images/icons/view-all.svg'
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap'
import ZoomInMapIcon from '@mui/icons-material/ZoomInMap'
import { CardMedia, Dialog } from '@mui/material'
import ExpandDetail from './UIComponent/ExpandDetail.js'
import {
  analyticsEvent,
  eventName,
} from '../common/Analytics/AnalyticsEvent.js'
import { useRef } from 'react'
import useElementOnScreen from '../common/customHooks/useElementOnScreen.js'
import DetailVideoSlides from './UIComponent/DetailVideoSlides.js'
import GalleryView from './UIComponent/GalleryView.js'
import imageGallery from 'react-image-video-gallery'

// function scrollToAccept() {
//   const terms = document.querySelector('.detailPage');
//   if(!terms) {
//     return; //quit this there isn't that item on tha page
//   }
//   terms.addEventListner('scroll', function(e) {
//     console.log(e);
//   })
// }

const Index = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  let intersectTarget = useRef(null)
  const detailPageDataById = useSelector(fetchDetailPageState)

  // passing is_default to trip detail API
  const tripData = useSelector(fetchCurrentState)
  let is_default = tripData.is_default
  console.log('is_default>>>>', is_default)

  // Detecting if user scrolled to end of page
  useEffect(() => {
    // scroll event
    let el = document.querySelector('.MuiDialog-paperScrollPaper')
    console.log('>>>>>>el', el)
    el.addEventListener('scroll', handleScroll)
    return () => {
      el.removeEventListener('scroll', handleScroll)
    }
    function handleScroll() {
      // console.log(
      //   'window innerheight',
      //   ~~(el.scrollHeight - el.getBoundingClientRect().bottom),
      // )
      // console.log('newScrollHeight', ~~el.scrollTop)
      if (
        ~~el.scrollTop ===
        ~~(el.scrollHeight - el.getBoundingClientRect().bottom)
      ) {
        console.log('Reached Bottom')
        analyticsEvent.clickEvent(
          'Item detail',
          eventName.Item_detail_scrolled_till_end_of_page,
        )
      }
    }
  }, [])

  // DEV ENV TOKEN
  var tokenStr =
    '0fa77c70-0561-46d2unravel@123-9ab5-9b3aa054aebe-customer@unravelapp.com'

  // PROD ENV Token
  // var tokenStr =
  //   '0c7783c9-6478-4781unravel@123-8b91-d7a190ceca34-customer@unravelapp.com'

  var host = window.location.hostname
  if (host === 'trip.unravelapp.com' || host === 'trips.unravelapp.com') {
    // PROD ENV Token
    var tokenStr =
      '0c7783c9-6478-4781unravel@123-8b91-d7a190ceca34-customer@unravelapp.com'
  }

  useEffect(() => {
    window.scrollTo(0, 0)

    // console.log('>>>>>>>detailPageRef', detailPageRef)
    // var id = location.state.item_id
    // var id = '329a9b4d-592f-4e04-9b5f-e4b6ff60752a'
    var id = props.detailPageId

    console.log('>>>>>>', id)
    dispatch(
      getDetailPageDataAsync(
        `api/v1/item/details?itemId=${id}&isDefault=${props.isDefault}`,
        {
          headers: { token: `${tokenStr}` },
        },
      ),
    )

    dispatch(
      getVideosGalleryDataAsync(
        `api/v1/item/videos?itemId=${id}&pageNumber=0&pageSize=20`,
        {
          headers: { token: `${tokenStr}` },
        },
      ),
    )

    dispatch(
      getImagesGalleryDataAsync(
        `api/v1/item/images?itemId=${id}&pageNumber=0&pageSize=20`,
        {
          headers: { token: `${tokenStr}` },
        },
      ),
    )

    // unmounted state
    return () => {
      console.log('*******************DETAILPAGE UNMOUNTED')
      // detailPageRef.current.removeEventListener('scroll', handleScroll)
      // data = {}
      // flushDetailPageData();
      dispatch(flushDetailPageData())
      dispatch(flushImagesGalleryData())
      dispatch(flushVideosGalleryData())
      // window.onpopstate = null
    }
  }, [dispatch, props.detailPageId])
  console.log('>>>>>>>>>>detailPageData : ', detailPageDataById)

  // const [data, setData] = useState(activity_data.data)
  // console.log('data::', activity_data.data)
  // const [data, setData] = useState(attraction_data.data)
  // console.log('>>>>>>>>>> Attration data : ', data)

  //console.log('>>>>>>>>>> Hotel data : ', data)
  // const [data, setData] = useState(detailPageDataById)

  // const [data, setData] = useState(hotel_data.data)
  let data = {}
  data = detailPageDataById
  console.log('>>>>>>>>>>data : ', data)

  const ActivityUIComponentName = {
    media: 'media',
    metaData: MetaDataLayout,
    photos: 'photos',
    mediaWithVideo: 'mediaWithVideo',
    mapView: 'mapView',
    component: 'component',
    stayTips: StayTipsLayout,
    hotelBanner: 'hotelBanner',
    mainBulletList: BulletListLayout,
    customList: CustomListLayout,
    keyValue: KeyValueLayout,
    banner: 'banner',
    tripInfo: 'tripInfo',
    hotelAmenities: HotelAmenityLayout,
    hotelTransports: HotelTransportLayout,
    tripBanner: TripBannerLayout,
    review: ReviewLayout,
    atAGlance: AtAGlanceLayout,
    hotelSeparator: HotelSeparatorLayout,
    additionalInfo: AdditionalInfoLayout,
    displayProperties: DisplayPropertyLayout,
    // source: EmptyComponent, //SourceLayout,
    source: SourceLayout,
    text: TextLayout,
    bulletList: BulletListLayout,
    stayFeatured: StayFeaturedLayout,
    checkList: CheckListLayout,
    lineSeparator: LineSeparatorLayout,
  }

  let layouts = data.layout
  //console.log('>>>>>>>>>>>>>>>>>>before layouts', layouts)
  layouts = orderBy(layouts, ['order'], ['asc'])
  // console.log('>>>>>>>>>>>>>>>>>>after layouts', layouts)

  console.log('>>>localmediastate', localStorage.getItem('mediaMuteState'))
  const [isDetailMuted, setisDetailMuted] = useState(
    localStorage.getItem('mediaMuteState') === 'true',
  )

  // fetch Images Gallery
  let imagesGalleryArray = useSelector(fetchImagesGallery)
  // let imagesArrayFromAPIFromAPI = []
  let imagesArrayFromAPI = imagesGalleryModal(imagesGalleryArray)
  // let imagesSlides = []
  let imagesSlides = imagesSlidesModal(imagesGalleryArray)
  console.log('>>>>ImagesGalleryArray::', imagesGalleryArray)

  // fetch videos Gallery
  let videosGalleryArray = useSelector(fetchVideosGallery)
  // let videosArray = []
  let videosArray = videosGalleryModal(videosGalleryArray)
  // let videoSlides = []
  let videoSlides = videosSlidesModal(videosGalleryArray)
  console.log('>>>>VideosGalleryArray::', videosArray)

  // fetch dotw images
  let hotelPropertiesImages = getImagesFromHotelProperties(data)
  console.log('>>>detailPageImages', hotelPropertiesImages)
  if (!isEmpty(data)) {
    var detailImages = []
    detailImages = data.images.map((img, index) => {
      return {
        src: img.twoX.fullscreen,
        src2: img.twoX.square,
        fullscreen: img.twoX.fullscreen,
        thumbnail: img.twoX.square,
        width: '100',
        height: '100',
        key: index,
      }
    })
    detailImages = detailImages.concat(imagesArrayFromAPI)
    detailImages = detailImages.concat(hotelPropertiesImages)
    // console.log('>>>FinalImages::::', detailImages)
  }

  let hotelPropertiesImagesSlides = getImagesSlidesFromHotelProperties(data)
  console.log('>>>detailPageImages', hotelPropertiesImagesSlides)
  if (!isEmpty(data)) {
    var detailImagesSlides = []
    detailImagesSlides = data.images.map((img, index) => {
      return {
        src: img.twoX.fullscreen,
        src2: img.twoX.square,
        fullscreen: img.twoX.fullscreen,
        thumbnail: img.twoX.square,
        width: '100%',
        height: '100%',
        key: index,
      }
    })
    detailImagesSlides = detailImagesSlides.concat(imagesSlides)
    detailImagesSlides = detailImagesSlides.concat(hotelPropertiesImagesSlides)
    // console.log('>>>FinalImages::::', detailImagesSlides)
  }

  // fetching json videos and concating them with API Videos
  if (!isEmpty(data)) {
    var detailPageVideos = []
    detailPageVideos = data.videos.map((item, index) => {
      return {
        src: item.image.twoX.square,
        thumbnail: item.image.twoX.square,
        src2: item.video_url.med,
        height: '400',
        width: '400',
        key: index,
      }
    })
    detailPageVideos = detailPageVideos.concat(videosArray)
  }

  if (!isEmpty(data)) {
    var detailPageVideosSlides = []
    detailPageVideosSlides = data.videos.map((item, index) => {
      return {
        sources: [
          {
            src: item.video_url.med,
            type: 'video/mp4',
          },
        ],
        height: '100%',
        width: '100%',
        //   key: index,
        poster: item.image.twoX.square,
        type: 'video',
        description: item.caption,
      }
    })
    detailPageVideosSlides = detailPageVideosSlides.concat(videoSlides)
  }

  // if (!isEmpty(data)) {
  //   var images = data.images.map((img) => ({
  //     src: img.twoX.square,
  //     thumbnail: img.twoX.thumbnail,
  //     fullscreen: img.twoX.fullscreen,
  //   }))

  // if (!isEmpty(imagesArrayFromAPI)) {
  //   images.push(...imagesArrayFromAPI)
  // }
  // images and video array
  // var videosArray = data.videos.map((video) => ({
  //   src: video.video_url.med,
  //   thumbnail: video.image.twoX.square,
  // }))
  // console.log('Videos Array >>>>> :: ', videos)
  // }

  // Gallery view
  // dialogues box
  const [openGallery, setOpenGallery] = useState(false)

  const handleGalleryViewOpen = () => {
    setOpenGallery(true)
  }

  const handleGalleryViewClose = () => {
    setOpenGallery(false)
  }
  //----

  return (
    <div ref={intersectTarget}>
      {!isEmpty(data) ? (
        <Box sx={{ width: '100%' }}>
          {/* React Carousel */}
          <div className="gallery-div " style={{ position: 'relative' }}>
            <div
              className="logo-container"
              style={{
                //   display: 'flex',
                //   position: 'absolute',
                //   padding: '0px 20px 0px 20px',
                //   height: '100px',
                //   width: '90%',
                //   // width: '-webkit-fill-available',
                //   justifyContent: 'space-between',
                //   alignItems: 'center',
                background:
                  'linear-gradient( 0deg, rgba(11, 12, 21, 0) 0%, rgba(11, 12, 21, 0.3) 34.9%, rgba(11, 12, 21, 0.6) 97.92% )',
                //   zIndex: 2,
              }}
            >
              <div
                style={{ cursor: 'pointer', padding: '10px' }}
                onClick={() => {
                  props.handleDetailPageClose()
                  analyticsEvent.clickEvent(
                    'Item detail',
                    eventName.Item_detail_back_button_pressed,
                  )
                }}
              >
                <img src={navigateBack} alt="navigate-back"></img>
              </div>
              <div
                onClick={() => {
                  analyticsEvent.clickEvent(
                    'Item detail',
                    eventName.Item_detail_share_opened,
                  )
                }}
              >
                <ShareButton
                  eventName={eventName.Item_detail_share_success}
                  category={'Item detail'}
                ></ShareButton>
              </div>
            </div>
            {/* <Carousel
              images={images}
              style={{
                width: '100%',
                background: 'transparent',
                // color: 'white',
              }}
              onTap={() => {
                analyticsEvent.clickEvent(
                  'Item detail',
                  eventName.Item_detail_view_all_selected_in_media,
                )
              }}
              // className="dynamic-height"
              hasMediaButton={false}
              hasIndexBoard={false}
              hasThumbnails={false}
              hasThumbnailsAtMax={true}
              shouldMaximizeOnClick={true}
              shouldMinimizeOnClick={true}
              hasDotButtons={images.length > 1 ? 'bottomLeft' : false}
              hasDotButtonsAtMax={true}
              hasSizeButton="bottomRight"
              hasSizeButtonAtMax="topRight"
              // objectFitAtMax="cover"
              leftIcon={
                images.length > 1 ? (
                  <span>
                    <img src={newLeft} alt="go-left"></img>
                  </span>
                ) : (
                  false
                )
              }
              rightIcon={
                images.length > 1 ? (
                  <span>
                    <img src={newRight} alt="go-right"></img>
                  </span>
                ) : (
                  false
                )
              }
              activeIcon={
                <span className="icon-text" role="img" aria-label="active">
                  <img
                    src={active}
                    alt="active"
                    style={{
                      marginBottom: '15px',
                      marginLeft: '5px',
                      marginRight: '5px',
                    }}
                  ></img>
                </span>
              }
              passiveIcon={
                <span className="icon-text" role="img" aria-label="passive">
                  <img
                    src={inactive}
                    alt="inactive"
                    style={{
                      marginBottom: '15px',
                      marginLeft: '5px',
                      marginRight: '5px',
                    }}
                  ></img>
                </span>
              }
              maxIcon={
                // <ZoomOutMapIcon
                //   fontSize="large"
                //   sx={{ color: 'white', margin: '10px' }}
                // />
                <div style={{}}>
                  <span
                    style={{ margin: '8px', opacity: '1' }}
                    onClick={() => {
                      analyticsEvent.clickEvent(
                        'Item detail',
                        eventName.Item_detail_view_all_selected_in_media,
                      )
                    }}
                  >
                    <img
                      src={viewAll}
                      alt="view-all"
                      style={{ margin: '8px', opacity: '1' }}
                    ></img>
                  </span>
                </div>
              }
              minIcon={
                <ZoomInMapIcon
                  fontSize="large"
                  sx={{ color: 'white', margin: '10px' }}
                />
              }
            /> */}
            <Swiper
              slidesPerView={1}
              spaceBetween={30}
              loop={true}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="detail-page-swiper"
              style={{ background: 'white' }}
            >
              {detailPageVideos.map((video, index) => {
                console.log('>>>>>>>>video src : ', video)
                return (
                  <SwiperSlide key={index}>
                    <DetailVideoSlides
                      video={video}
                      setisDetailMuted={setisDetailMuted}
                      isDetailMuted={isDetailMuted}
                    />
                  </SwiperSlide>
                )
              })}
              {detailImages.map((img, index) => {
                if (index <= 9) {
                  return (
                    <SwiperSlide key={index}>
                      <CardMedia
                        component="img"
                        className="dynamic-height"
                        alt="media-pics"
                        // height="250"
                        style={{
                          width: '100%',
                          objectFit: 'cover',
                          background: 'transparent',
                        }}
                        image={img.src2}
                        // src={element.video.src}
                      />
                    </SwiperSlide>
                  )
                }
              })}
            </Swiper>
            <div
              style={{
                display: 'flex',
                position: 'absolute',
                padding: '0px 30px 0px 20px',
                height: '73px',
                width: '-webkit-fill-available',
                justifyContent: 'space-between',
                alignItems: 'center',
                background:
                  'linear-gradient(360deg, rgba(11, 12, 21, 0.6) -10.12%, rgba(11, 12, 21, 0) 100%)',
                bottom: '0px',
                // zIndex: '1',
              }}
            ></div>
            <img
              src={viewAll}
              onClick={() => {
                handleGalleryViewOpen()
                setisDetailMuted(true)
                analyticsEvent.clickEvent(
                  'Item detail',
                  eventName.Item_detail_view_all_selected_in_media,
                )
              }}
              style={{
                position: 'absolute',
                bottom: 'top',
                color: 'white',
                right: '15px',
                zIndex: '100',
                bottom: '10px',
                cursor: 'pointer',
              }}
            ></img>
          </div>
          {/* End here */}

          <MetaDataLayout data={data} />
          {layouts.map((item, i) => {
            let getLayoutInfo = getDataForLayout(data, item)
            if (getLayoutInfo.length == 3) {
              let uiComponentName = getLayoutInfo[0]
              console.log('UI Component Name : ', uiComponentName)
              console.log('Component Name : ', getLayoutInfo[1].display_name)
              console.log('Component Layout : ', getLayoutInfo[1])
              console.log('Component Value : ', getLayoutInfo[2])

              if (!isEmpty(uiComponentName)) {
                let componentLayout = getLayoutInfo[1]
                let componentValue = getLayoutInfo[2]

                if (!isEmpty(componentValue) && !isEmpty(componentLayout)) {
                  const SomeComponent = ActivityUIComponentName[uiComponentName]
                  console.log(' >>>>>>>> Type ', typeof SomeComponent)
                  if (typeof SomeComponent === 'function') {
                    console.log('>>>>> Layout created >>>>>>')
                    return (
                      <SomeComponent
                        layout={componentLayout}
                        value={componentValue}
                        handleDetailPageClose={props.handleDetailPageClose}
                        key={v4()}
                      />
                    )
                    //return <SomeComponent item={item} data={data} />
                  } else {
                    console.log('Layout component value is not correct !!!!!!')
                  }
                } else {
                  console.log('Layout not created yet !!!!!!')
                }
              } else {
                console.log('Layout not handlled yet !!!!!!')
              }
            }
          })}
          {/* <button
            onClick={(e) => {
              e.preventDefault()
              handleExpandPageOpen()
            }}
          >
            open dialog
          </button> */}
          {/* <div >at the bottom</div> */}
          <div
            style={{
              padding: '50px 20px',
            }}
          >
            <img
              src={goBack}
              alt="go-back"
              className="go-back"
              onClick={() => {
                props.handleDetailPageClose()
                analyticsEvent.clickEvent(
                  'Item detail',
                  eventName.Item_detail_back_button_pressed,
                )
              }}
            ></img>
          </div>

          {/* Dialog Page */}

          {/* content here---- */}
          <GalleryView
            openGallery={openGallery}
            handleGalleryViewClose={handleGalleryViewClose}
            images={detailImages}
            videosArray={detailPageVideos}
            videoSlides={detailPageVideosSlides}
            setisDetailMuted={setisDetailMuted}
            isDetailMuted={isDetailMuted}
            id={props.detailPageId}
            tokenStr={tokenStr}
            totalImagesPages={imagesGalleryArray.page}
            totalVideosPages={videosGalleryArray.page}
            imagesSlides={detailImagesSlides}
          />

          {/* ended here */}
        </Box>
      ) : (
        <Loader />
      )}
    </div>
  )
}

export default Index

/*
  const [data1, setData1] = useState([
    {
      text: 'Itinerary This is a typical itinerary for this product.',
      style: 'none',
    },
    {
      text: 'Stop at: Basilica of Born Jesus, Old Goa Road, Goa Velha 403402',
      style: 'none',
    },
    {
      text:
        'Meet your guide at your Goa hotel and travel in private air conditioned comfort to the UNES...',
      style: 'none',
    },
  ])
  const [data2, setData2] = useState([
    {
      text: 'Confirmation will be received after at time of booking',
      style: 'disc',
    },
    {
      text:
        'A small amount of walking is involved. Comfortable walking shoes are recommended',
      style: 'disc',
    },
    {
      text: 'Not wheelchair accessible',
      style: 'disc',
    },
    {
      text: 'Near public transportation',
      style: 'disc',
    },
    {
      text: 'Not wheelchair accessible',
      style: 'disc',
    },
    {
      text: 'Infants must sit on laps',
      style: 'disc',
    },
  ])
  const [data3, setData3] = useState([
    {
      text:
        'Traveler pickup is offered. Pick up and drop off location for this tour Panaji / Calangute / Cabdolim / Baga. Supplement coast will be applicable for pick up beyond the above set pickup point turns to original departure point.',
      style: 'none',
    },
  ])

  const [corouselData, setCorouselData] = useState([
    {
      image: require('../../assets/images/viator.svg').default,
    },
    {
      image: require('../../assets/images/rafting.png').default,
    },
    {
      image: require('../../assets/images/rafting.png').default,
    },
  ])
*/
